import $ftaEG$arAEmodulejs from "./ar-AE.mjs";
import $ftaEG$bgBGmodulejs from "./bg-BG.mjs";
import $ftaEG$csCZmodulejs from "./cs-CZ.mjs";
import $ftaEG$daDKmodulejs from "./da-DK.mjs";
import $ftaEG$deDEmodulejs from "./de-DE.mjs";
import $ftaEG$elGRmodulejs from "./el-GR.mjs";
import $ftaEG$enUSmodulejs from "./en-US.mjs";
import $ftaEG$esESmodulejs from "./es-ES.mjs";
import $ftaEG$etEEmodulejs from "./et-EE.mjs";
import $ftaEG$fiFImodulejs from "./fi-FI.mjs";
import $ftaEG$frFRmodulejs from "./fr-FR.mjs";
import $ftaEG$heILmodulejs from "./he-IL.mjs";
import $ftaEG$hrHRmodulejs from "./hr-HR.mjs";
import $ftaEG$huHUmodulejs from "./hu-HU.mjs";
import $ftaEG$itITmodulejs from "./it-IT.mjs";
import $ftaEG$jaJPmodulejs from "./ja-JP.mjs";
import $ftaEG$koKRmodulejs from "./ko-KR.mjs";
import $ftaEG$ltLTmodulejs from "./lt-LT.mjs";
import $ftaEG$lvLVmodulejs from "./lv-LV.mjs";
import $ftaEG$nbNOmodulejs from "./nb-NO.mjs";
import $ftaEG$nlNLmodulejs from "./nl-NL.mjs";
import $ftaEG$plPLmodulejs from "./pl-PL.mjs";
import $ftaEG$ptBRmodulejs from "./pt-BR.mjs";
import $ftaEG$ptPTmodulejs from "./pt-PT.mjs";
import $ftaEG$roROmodulejs from "./ro-RO.mjs";
import $ftaEG$ruRUmodulejs from "./ru-RU.mjs";
import $ftaEG$skSKmodulejs from "./sk-SK.mjs";
import $ftaEG$slSImodulejs from "./sl-SI.mjs";
import $ftaEG$srSPmodulejs from "./sr-SP.mjs";
import $ftaEG$svSEmodulejs from "./sv-SE.mjs";
import $ftaEG$trTRmodulejs from "./tr-TR.mjs";
import $ftaEG$ukUAmodulejs from "./uk-UA.mjs";
import $ftaEG$zhCNmodulejs from "./zh-CN.mjs";
import $ftaEG$zhTWmodulejs from "./zh-TW.mjs";

var $835c96616a7cb4f9$exports = {};


































$835c96616a7cb4f9$exports = {
    "ar-AE": $ftaEG$arAEmodulejs,
    "bg-BG": $ftaEG$bgBGmodulejs,
    "cs-CZ": $ftaEG$csCZmodulejs,
    "da-DK": $ftaEG$daDKmodulejs,
    "de-DE": $ftaEG$deDEmodulejs,
    "el-GR": $ftaEG$elGRmodulejs,
    "en-US": $ftaEG$enUSmodulejs,
    "es-ES": $ftaEG$esESmodulejs,
    "et-EE": $ftaEG$etEEmodulejs,
    "fi-FI": $ftaEG$fiFImodulejs,
    "fr-FR": $ftaEG$frFRmodulejs,
    "he-IL": $ftaEG$heILmodulejs,
    "hr-HR": $ftaEG$hrHRmodulejs,
    "hu-HU": $ftaEG$huHUmodulejs,
    "it-IT": $ftaEG$itITmodulejs,
    "ja-JP": $ftaEG$jaJPmodulejs,
    "ko-KR": $ftaEG$koKRmodulejs,
    "lt-LT": $ftaEG$ltLTmodulejs,
    "lv-LV": $ftaEG$lvLVmodulejs,
    "nb-NO": $ftaEG$nbNOmodulejs,
    "nl-NL": $ftaEG$nlNLmodulejs,
    "pl-PL": $ftaEG$plPLmodulejs,
    "pt-BR": $ftaEG$ptBRmodulejs,
    "pt-PT": $ftaEG$ptPTmodulejs,
    "ro-RO": $ftaEG$roROmodulejs,
    "ru-RU": $ftaEG$ruRUmodulejs,
    "sk-SK": $ftaEG$skSKmodulejs,
    "sl-SI": $ftaEG$slSImodulejs,
    "sr-SP": $ftaEG$srSPmodulejs,
    "sv-SE": $ftaEG$svSEmodulejs,
    "tr-TR": $ftaEG$trTRmodulejs,
    "uk-UA": $ftaEG$ukUAmodulejs,
    "zh-CN": $ftaEG$zhCNmodulejs,
    "zh-TW": $ftaEG$zhTWmodulejs
};


export {$835c96616a7cb4f9$exports as default};
//# sourceMappingURL=intlStrings.module.js.map
